<template>
	<div id="app">
		<audio controls id="audio" ref="audio" src="" style="height: 0; float: left"></audio>
		<router-view />
	</div>
</template>
<script>
	import { isMobileDevice } from '@/utils/device';
	// import {
	// 	mapState
	// } from 'vuex';
	
	const synth = window.speechSynthesis // 启用文本
	let msg = null
	// 特性检测：部分安卓 webview 不支持 SpeechSynthesisUtterance，
	// 顶层直接 new 未定义构造函数会抛错导致整页白屏，故先判断是否可用
	if (!isMobileDevice() && typeof SpeechSynthesisUtterance !== 'undefined') {
		msg = new SpeechSynthesisUtterance()
	}
	
	export default {
		data() {
			return {
				voiceDialog: false,
				userobj: '',
				audio: "",
				socket: null,
				socketSendTimer: null,
				isConnect: false,
				reConnectTimer: null,
				socketReconnectAllowed: false,

			};
		},
		watch: {
			'$store.state.uobj'(value) {
				this.userobj = value || ''
				if (sessionStorage.getItem("token")) {
					this.createSocket()
				}
			},
			'$route.path'(path) {
				if (path === '/Login' || !sessionStorage.getItem("token")) {
					this.destroySocket()
				}
			}
		},
		created() {
		
			
		},
		computed: {
		    // ...mapState([
		    //   'uobj' // 假设你的Vuex store中有一个名为'count'的状态
		    // ]),
		 
		    // 或者使用对象展开来进行更复杂的映射
		    // ...mapState({
		    //   localCount: state => state.count // 将store中的count状态映射到局部计算属性localCount
		    // })
		  },
		mounted() {
			this.audio = this.$refs.audio;
			this.userobj = this.$store.state.uobj;
			
			setTimeout(() => {
				if (this.$route.path !== "/Login" && sessionStorage.getItem("token"))
					this.voiceDialog = true;
			}, 1000);
			if (sessionStorage.getItem("token")) {
				this.createSocket()
			}
		},
		beforeDestroy() {
			this.destroySocket()
		},
		methods: {
			destroySocket() {
				this.socketReconnectAllowed = false
				// 关闭定时发送消息的计时器
				clearInterval(this.socketSendTimer)
				this.socketSendTimer = null

				// 如果重连计时器存在就清除它
				if (this.reConnectTimer) {
					clearTimeout(this.reConnectTimer)
					this.reConnectTimer = null
				}

				// 如果 socket 连接存在就关闭它，并置为 null
				if (this.socket) {
					this.socket.close()
					this.socket = null
				}

				// 标记为未连接状态
				this.isConnect = false
			},

			createSocket() {
				try {
					if (typeof WebSocket === "undefined") {
						alert("您的浏览器不支持socket");
					} else {
						if (this.isConnect) return;
						var userORMTB400ID
						// console.log(this.userobj)
						if (this.userobj.pertb005.pertb005cb00 == "CUS-2") {
							userORMTB400ID = this.userobj.ormtb410.ORMTB410ID //一级企业id

						}
						if (this.userobj.pertb005.pertb005cb00 == "CUS-1") {
							// var time = Date.parse(new Date());
							
							userORMTB400ID = 'CUS-1_' + this.userobj.pertb005.pertb005id //一级企业id

						}

						let tokenUser = sessionStorage.getItem("token");
						let token = userORMTB400ID;
						if (!tokenUser || tokenUser === 'null') return
						this.socketReconnectAllowed = true
						let path = `wss://${'feishazoushi.cn'}/im/${token}`;
						this.socket = new WebSocket(path); // 实例化socket
						// console.log(this.socket)
						this.init();
					}
				} catch (error) {
					// 如果无法连接上webSocket 那么重新连接！可能会因为服务器重新部署，或者短暂断网等导致无法创建连接
					this.reConnect();
				}
			},


			reConnect() {
				// 重连函数
				if (!this.socketReconnectAllowed || this.$route.path === '/Login' || !sessionStorage.getItem('token')) return;
				// 延迟5秒重连  避免过多次过频繁请求重连
				this.reConnectTimer && clearTimeout(this.reConnectTimer);
				this.reConnectTimer = setTimeout(() => {
					this.createSocket();
				}, 5000);
			},
			init() {
				// 初始化
				this.isConnect = true;
				this.socket.onopen = this.open; // 监听socket连接
				this.socket.onerror = this.error; // 监听socket错误信息
				this.socket.onmessage = this.getMessage; // 监听socket消息
				this.socket.onclose = this.close; // 监听socket关闭

			},
			open() {
				this.send();
			},

			// playVoice() {
			// 	this.handleSpeak('厂家调价了') // 传入需要播放的文字
			// },
			// 语音播报的函数
			handleSpeak(text) {
				if (!msg) return
				msg.text = text // 内容
				msg.lang = 'zh-CN' // 使用的语言:中文
				msg.volume = 1 // 声音音量：1
				msg.rate = 1 // 语速：1
				msg.pitch = 1 // 音高：1
				// synth.speak(msg) // 播放
			},
			// 语音停止
			handleStop(e) {
				if (!msg) return
				msg.text = e
				msg.lang = 'zh-CN'
				// synth.cancel(msg) // 取消该次语音播放
			},

			error() {
				clearInterval(this.socketSendTimer);
				this.isConnect = false;
				if (this.socketReconnectAllowed && this.$route.path !== '/Login' && sessionStorage.getItem('token')) {
					this.reConnect();
				}
			},
			getMessage(msg) {
				if (msg.data !== "received") {
					let data = JSON.parse(msg.data);
					// console.log(data)
					if (data) {
						let _this = this; //函数作用域问题
						var titleCont
						if (data.message === "您有新的派单需要审核") {
							titleCont = '订单审核通知'
						}
						if (data.message === "客户余额异常") {
							titleCont = '客户余额异常通知'
						}
						if (data.message === "有厂家物料调价了") {
							titleCont = '调价通知'
						}
						if (data.message === "有新的运费订单申请") {
							titleCont = '运单审核'
						}
						if (data.message === "有客户余额不足无法出厂结算") {
							titleCont = '结算异常通知'
						}
						setTimeout(() => {
							const h = _this.$createElement;

							this.$notify({
								title: titleCont,
								message: h(
									"i", {
										style: "color: red"
									},
									data.orderId + data.message + "!!!"
								),
								// message: data.orderId+data.message,
								dangerouslyUseHTMLString: true,
								duration: "3000",
								position: "bottom-right",
								// duration: 120000,
								onClick() {
								_this.defineCallBack(data.data.order_no); //自定义回调,message为传的参数
								}
							});
							if (data.message === "您有新的派单需要审核") {
								this.audio.src = require("@/assets/send_order.mp3");
								this.audio.play();
							}
							if (data.message === "客户余额异常") {
								this.audio.src = require("@/assets/qk_tsy.mp3");
								this.audio.play();
							}

							if (data.message === "有厂家物料调价了") {
								// this.audio.src = require("@/assets/qk_tsy.mp3");
								// this.audio.play();

								this.handleSpeak(data.orderId)

							}

							if (data.message === "有新的运费订单申请") {
								// this.audio.src = require("@/assets/qk_tsy.mp3");
								// this.audio.play();

								this.handleSpeak(data.orderId)

							} 
							
							if (data.message === "有客户余额不足无法出厂结算") {
								this.handleSpeak(data.orderId)
							}
							else {
											// this.audio.src = require("@/assets/send_order.mp3");
							}

						}, 3000);
					}
				}
			},
			defineCallBack(order_no) {
				localStorage.setItem("joker1", 1);
				this.$router.push({
					path: "/order/lists",
					query: {
						order_no: order_no,
					},
				});
			},
			send() {
				if (this.socketSendTimer) {
					clearInterval(this.socketSendTimer);
					this.socketSendTimer = null;
				}
				let token = sessionStorage.getItem("token");
				this.socketSendTimer = setInterval(() => {
					let params = {
						message: token,
					};
					//添加状态判断，当为OPEN时，发送消息
					if (this.socket && this.socket.readyState === 1) {
						if (token && token !== 'null') {
							this.socket.send(JSON.stringify(params));
						}
					}
					if (!sessionStorage.getItem("token")) {
						this.destroySocket()
					}
				}, 15 * 1000);
			},
			close(e) {
								clearInterval(this.socketSendTimer);
				this.isConnect = false;
				if (this.socketReconnectAllowed && this.$route.path !== '/Login' && sessionStorage.getItem('token')) {
					this.reConnect();
				}
			},
			allowVoicePlay() {
				this.audio.src = require("@/assets/send_order.mp3");
				this.voiceDialog = false;
			},
		},
	};
</script>
<style>
	/* 基础公共样式 */
	@import "./assets/publicCss/base.css";
	/*element组件样式 */
	@import "./assets/publicCss/elementBase.css";
	/*字体图标*/
	@import "./assets/icons/iconfont.css";
</style>
